// Hook listy szablonow kalkulacji do skopiowania -
// GET /sales-crm/clients/:cid/offers/:oid/positions/:pid/calculation-templates

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export type CalculationTemplatePriceType = 'UNIT' | 'TOTAL';

export interface ICalculationTemplatePosition {
  name: string | null;
  priceType: CalculationTemplatePriceType | null;
  priceNet: number | null;
  costNet: number | null;
}

export interface ICalculationTemplate {
  id: number;
  name: string | null;
  createdAt: string | null;
  valueNet: number | null;
  currency: string | null;
  clientId: number | null;
  clientName: string | null;
  /** Czy kalkulacja dotyczy bieżącego klienta (badge "Ten klient" w UI). */
  isSameClient: boolean | null;
  offerId: number | null;
  offerNumber: string | null;
  positions: ICalculationTemplatePosition[];
}

export interface ISalesCrmCalculationTemplatesResponse {
  relatedToProduct: ICalculationTemplate[];
  other: ICalculationTemplate[];
}

export interface IGetCalculationTemplatesParams {
  search?: string;
  limit?: number;
}

export const getSalesCrmCalculationTemplatesQueryKey = (
  clientId: number,
  offerId: string,
  positionId: number,
  search: string | undefined
) => ['salesCrm', 'calculationTemplates', clientId, offerId, positionId, search ?? null] as const;

const getSalesCrmCalculationTemplates = (
  clientId: number,
  offerId: string,
  positionId: number,
  params: IGetCalculationTemplatesParams
): Promise<ISalesCrmCalculationTemplatesResponse> =>
  axios.get(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/calculation-templates`,
    { params }
  );

export const useGetSalesCrmCalculationTemplates = (
  clientId: number,
  offerId: string,
  positionId: number,
  params: IGetCalculationTemplatesParams,
  options?: UseQueryOptions<ISalesCrmCalculationTemplatesResponse, IError>
) =>
  useQuery<ISalesCrmCalculationTemplatesResponse, IError>(
    getSalesCrmCalculationTemplatesQueryKey(clientId, offerId, positionId, params.search),
    () => getSalesCrmCalculationTemplates(clientId, offerId, positionId, params),
    {
      ...options,
      enabled:
        options?.enabled !== false &&
        clientId > 0 &&
        String(offerId).trim().length > 0 &&
        positionId > 0
    }
  );
